import React, { FC, useEffect, useState } from 'react';
import { Button } from 'antd';
import { ReactComponent as ControlIcon } from 'app/assets/images/redesign/control.svg';
import { ReactComponent as ArrowUpShortIcon } from 'app/assets/images/redesign/arrow-up-short.svg';
import { ReactComponent as ArrowDownShortIcon } from 'app/assets/images/redesign/arrow-down-short.svg';
import { RequestHistoryItem } from 'entities/RequestHistory/components/RequestHistoryItem';
import { IGroupedRequestHistoryGroup, IRequestHistory } from 'entities/RequestHistory/RequestHistory.models';
import { ERequestHistoryType } from 'entities/RequestHistory/RequestHistory.enum';
import { groupRequestHistoryGroupsByType } from 'entities/RequestHistory/RequestHistory.helper';
import { IFile } from 'entities/File/File.models';

interface IComponentProps {
  historyList: IRequestHistory[];
  marginBottomOffsetPx: number;
  scrollToEndOfHistoryList: () => void;
  downloadFile: (file: IFile) => void;
}

export const RequestDetailsUpdatesTab: FC<IComponentProps> = ({
  historyList,
  marginBottomOffsetPx,
  scrollToEndOfHistoryList,
  downloadFile,
}) => {
  const [groupedHistoryList, setGroupedHistoryList] = useState<IGroupedRequestHistoryGroup[]>([]);
  const [expandedKeys, setExpandedKeys] = useState<string[]>([]);

  const onExpandHistory = (expanded: boolean, key: string) => {
    if (expanded) {
      setExpandedKeys((prev) => prev.filter((item) => item !== key));
    } else {
      setExpandedKeys((prev) => [...prev, key]);
    }
  };

  useEffect(() => {
    const groupedRequestHistoryList = groupRequestHistoryGroupsByType(historyList);

    setGroupedHistoryList(groupedRequestHistoryList);
  }, [historyList]);

  useEffect(() => {
    scrollToEndOfHistoryList();
  }, [groupedHistoryList, marginBottomOffsetPx]);

  return (
    <div className="request-history" style={{ marginBottom: `calc(${marginBottomOffsetPx}px + 30px)` }}>
      {groupedHistoryList.map((group) => {
        const expanded = expandedKeys.includes(group.key);

        if (group.type === ERequestHistoryType.SupplyStatusChanged) {
          return (
            <div key={group.key} className="request-history__item request-history__item-expand-wrapper">
              <div className="mb-9 request-history__item">
                <div className="request-history__item-icon">
                  <ControlIcon />
                </div>

                <div className="request-history__item-container">
                  <div className="request-history__item-expand-container">
                    <span className="text-controls-accent">{`${group.logs.length} изменений статуса`}</span>

                    <Button
                      className="request-history__item-expand-btn"
                      icon={
                        expanded ? (
                          <ArrowUpShortIcon className="icon-arrow-up-short-dark-grey" />
                        ) : (
                          <ArrowDownShortIcon className="icon-arrow-down-short-dark-grey" />
                        )
                      }
                      onClick={() => onExpandHistory(expanded, group.key)}
                    />
                  </div>
                </div>
              </div>

              {group.logs.map((item) => {
                if (!expanded) {
                  return null;
                }

                return <RequestHistoryItem key={item.key} item={item} />;
              })}
            </div>
          );
        }

        return group.logs.map((item) => <RequestHistoryItem key={item.key} item={item} downloadFile={downloadFile} />);
      })}
    </div>
  );
};
